<template>
  <ButtonDropdownOptions data_test="dropdown-help">
    <template #custom_trigger>
      <div
        v-tooltip.bottom="$t('client.labels.helpcenter')"
        class="flex size-8 cursor-pointer items-center justify-center rounded-full text-neutral-500 transition-colors duration-150 hover:bg-selected hover:text-neutral-800"
        role="button"
        :aria-label="$t('client.labels.helpcenter')"
      >
        <AppIcon name="regular-circle-question" />
      </div>
    </template>

    <DropdownOption
      v-if="is_employee"
      data_test="help-whats-new"
      @click="router.push({ name: ROUTES_EMPLOYEES.CLIENT_WHATS_NEW })"
    >
      <AppIcon
        name="regular-bullhorn"
        fixed-width
        size="sm"
      />
      <span>{{ $t('whats_new.title') }}</span>
      <AppTag
        v-if="news_posts_unread_count"
        class="ml-auto"
        :value="String(news_posts_unread_count)"
        severity="success"
        rounded
      />
    </DropdownOption>
    <DropdownOption
      data_test="help-intercom"
      @click="openSupportChat()"
    >
      <AppIcon
        name="regular-comment"
        fixed-width
        size="sm"
      />
      <span>{{ $t('client.labels.chatWithUs') }}</span>
    </DropdownOption>
    <DropdownOption
      data_test="help-helpcenter"
      :href="help_url"
    >
      <AppIcon
        name="regular-circle-question"
        fixed-width
        size="sm"
      />
      <span>{{ $t('client.labels.helpcenter') }}</span>
    </DropdownOption>
    <DropdownOption
      v-if="client_is_trial"
      data_test="help-book-demo"
      :href="BOOK_DEMO_URL"
    >
      <AppIcon
        name="regular-calendar"
        fixed-width
        size="sm"
      />
      <span>{{ $t('client.labels.bookADemo') }}</span>
    </DropdownOption>
  </ButtonDropdownOptions>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import AppTag from '@/app/shared_components/AppTag.vue';
import { HelpCenter, PROFILE_TYPES, Tenant } from '@/app/data/model_constants';
import { ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import useSupportChat from '@/composables/useSupportChat';
import { mapGetters } from '@/store/lib/vue3helpers.js';

const BOOK_DEMO_URL = 'https://meetings.hubspot.com/marcus-vanhoonacker/video-call-45';

const router = useRouter();
const { openSupportChat } = useSupportChat();
const { current_profile, current_client, news_posts_unread_count } = mapGetters([
  'current_profile',
  'current_client',
  'news_posts_unread_count',
]);

const client_is_trial = computed(
  () => current_client.value && current_client.value.attributes.status === Tenant.STATUS_TRIAL,
);

const help_collection_id = computed(() =>
  current_profile.value && current_profile.value.type === PROFILE_TYPES.PARTNER
    ? HelpCenter.COLLECTION_ID_PARTNER
    : HelpCenter.COLLECTION_ID_EMPLOYEE,
);

const help_url = computed(() => {
  if (!current_profile.value) return '';
  return `https://help.ziggu.app/${current_profile.value.attributes.language}/collections/${help_collection_id.value}`;
});

const is_employee = computed(() => current_profile.value && current_profile.value.type === PROFILE_TYPES.EMPLOYEE);
</script>
